<div mat-dialog-content>
  <div class="title title-lg confirm-dialog-text">Update Error!</div>
  <ng-container [ngSwitch]="data.errorType">
    <div *ngFor="let error of errors">
      {{error}}
    </div>
    <p *ngSwitchCase="'failedSeatsUpdate'">
      Failed to save changes for the following residents. Please try again later.</p>
    <ul>
      <li *ngFor="let seat of failedResModels">
        {{seat.lastName}}, {{seat.firstName}}
      </li>
    </ul>
  </ng-container>
</div>
`